import { retrieveMember } from "../../../../redux/admin-slices/member.slice";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { Box, Grid2 as Grid, Typography } from "@mui/material";

function Details() {
  const { userId } = useParams();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);

  const { refresh, loadings } = useSelector((state) => state.otherSlice);
  useEffect(() => {
    dispatch(retrieveMember({ userId }))
      .unwrap()
      .then(setData)
      .catch(() => { });
    // eslint-disable-next-line
  }, [refresh]);

  return (
    <Box sx={{ mt: 3 }}>
      <Box
        sx={{
          p: 3,
          width: "100%",
          borderRadius: "12px",
          bgcolor: "white",
          border: "1px solid #00000012",
        }}
      >
        {loadings?.retrieveSingle ? (
          <Typography>Loading...</Typography>
        ) : !data ? (
          <Typography>No member details found!</Typography>
        ) : (
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Field label="Member Name" value={data?.name} />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Field label="Member Email" value={data?.email} />
            </Grid>

            {data?.phone && (
              <Grid size={{ xs: 12, md: 6 }}>
                <Field label="Phone" value={data?.phone} />
              </Grid>
            )}
            {Number.isFinite(data?.age) && data.age > 0 && (
              <Grid size={{ xs: 12, md: 6 }}>
                <Field label="Age" value={data.age} />
              </Grid>
            )}

            {data?.bloodGroup && (
              <Grid size={{ xs: 12, md: 6 }}>
                <Field label="Blood Group" value={data?.bloodGroup} />
              </Grid>
            )}
            {data?.country && (
              <Grid size={{ xs: 12, md: 6 }}>
                <Field label="Country" value={data?.address?.country} />
              </Grid>
            )}
            {data?.state && (
              <Grid size={{ xs: 12, md: 6 }}>
                <Field label="State" value={data?.address?.state} />
              </Grid>
            )}
            {data?.city && (
              <Grid size={{ xs: 12, md: 6 }}>
                <Field label="City" value={data?.address?.city} />
              </Grid>
            )}
            {data?.street && (
              <Grid size={{ xs: 12, md: 6 }}>
                <Field label="Street" value={data?.address?.street} />
              </Grid>
            )}
            {data?.zip && (
              <Grid size={{ xs: 12, md: 6 }}>
                <Field label="Zip Code" value={data?.address?.zip} />
              </Grid>
            )}
          </Grid>
        )}
      </Box>
    </Box>
  );
}

// ---------------------- FIELD COMPONENT ----------------------
function Field({ label, value }) {
  return (
    <Box>
      <Typography fontSize={16} fontWeight="600" color="dark.light">
        {label}
      </Typography>

      <Box
        sx={{
          mt: 1,
          p: 1,
          borderRadius: "8px",
          fontWeight: 400,
          border: "1px solid",
          color: "dark.light",
          borderColor: "other.color2",
          bgcolor: "#fafafa",
        }}
      >
        {value}
      </Box>
    </Box>
  );
}

export default Details;
